<div class="viestit-container">
  <h2>Lemonaid-viestit</h2>
  <mat-tab-group [(selectedIndex)]="valittuValilehti" mat-stretch-tabs="false">
    @for (valilehti of valilehdet; track valilehti.tyyppi) {
      <mat-tab [label]="valilehti.otsikko">
        <ng-template matTabContent>
          <div class="valilehden-sisalto">
            <p class="viestin-kuvaus">{{ valilehti.kuvaus }}</p>

            @if (valilehti.julkaistu()) {
              <div class="julkaisutila julkaisutila-julkaistu">Julkaistu {{ valilehti.julkaistu().julkaistu | date: 'd.M.yyyy HH:mm' }}</div>
            } @else {
              <div class="julkaisutila">Ei julkaistua viestiä</div>
            }

            <mat-form-field class="viesti-kentta" appearance="outline">
              <mat-label>Viesti</mat-label>
              <textarea matInput rows="5" [formField]="valilehti.viestiKentta"></textarea>
            </mat-form-field>

            <div class="viesti-napit">
              <app-secondary-button actionId="Tallenna vedos" [actionContext]="[valilehti.tyyppi]" [disabled]="valilehti.tallennetaan() || valilehti.ladataan()" (click)="tallennaVedos(valilehti)">Tallenna vedos</app-secondary-button>
              @if (valilehti.julkaistu()) {
                <app-secondary-button actionId="Poista julkaisu" [actionContext]="[valilehti.tyyppi]" [disabled]="valilehti.tallennetaan() || valilehti.ladataan()" (click)="poistaJulkaisu(valilehti)">Poista julkaisu</app-secondary-button>
              }
              <app-primary-button actionId="Julkaise" [actionContext]="[valilehti.tyyppi]" [disabled]="valilehti.tallennetaan() || valilehti.ladataan()" (click)="julkaise(valilehti)">Julkaise</app-primary-button>
            </div>

            <h3>Historia</h3>
            @if (valilehti.historia().length) {
              <table class="historia-taulukko">
                <thead>
                  <tr>
                    <th>Aika</th>
                    <th>Toiminto</th>
                    <th>Tekijä</th>
                    <th>Viesti</th>
                  </tr>
                </thead>
                <tbody>
                  @for (rivi of valilehti.historia(); track rivi.avain) {
                    <tr>
                      <td>{{ rivi.luotu | date: 'd.M.yyyy HH:mm' }}</td>
                      <td>{{ annaToiminnonNimi(rivi.toiminto) }}</td>
                      <td>{{ rivi.luojanEmail }}</td>
                      <td class="historia-viesti">{{ rivi.viesti }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else if (!valilehti.ladataan()) {
              <div class="ei-historiaa">Ei historiaa</div>
            }
          </div>
        </ng-template>
      </mat-tab>
    }
    <mat-tab label="Sovellusversiot">
      <ng-template matTabContent>
        <div class="valilehden-sisalto">
          <p class="viestin-kuvaus">Flutter-sovelluksen versiovaatimukset. Sovellus vertaa arvoja binäärin build-numeroon (pubspecin version-kentän +osa). Tyhjä kenttä tarkoittaa, ettei rajoitusta ole.</p>

          @if (sovellusversiot.webVersio()) {
            <div class="julkaisutila">Lemonaid-webin versio (deploy asettaa): {{ sovellusversiot.webVersio() }}</div>
          }

          <mat-form-field class="versio-kentta" appearance="outline">
            <mat-label>Pienin sallittu build-numero (flutterCellPhoneMin)</mat-label>
            <input matInput type="number" step="1" [formField]="sovellusversiot.minKentta" />
            <mat-hint>Tätä vanhemmalla binäärillä sovellusta ei voi käyttää — pakottava päivitysruutu</mat-hint>
            @if (onkoVirhe(sovellusversiot.minKentta, 'min')) {
              <mat-error>Arvo voi olla vähintään {{ annaAlaraja(sovellusversiot.minKentta, minRajat()) }}</mat-error>
            }
            @if (onkoVirhe(sovellusversiot.minKentta, 'max')) {
              <mat-error>Arvo voi olla enintään {{ minRajat()?.max }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="versio-kentta" appearance="outline">
            <mat-label>Viimeisin saatavilla oleva build-numero (flutterCellPhoneAvailable)</mat-label>
            <input matInput type="number" step="1" [formField]="sovellusversiot.availableKentta" />
            <mat-hint>Tätä vanhemmalle mutta sallitulle binäärille näytetään ohitettava päivityskehote</mat-hint>
            @if (onkoVirhe(sovellusversiot.availableKentta, 'min')) {
              <mat-error>Arvo voi olla vähintään {{ annaAlaraja(sovellusversiot.availableKentta, availableRajat()) }}</mat-error>
            }
            @if (onkoVirhe(sovellusversiot.availableKentta, 'max')) {
              <mat-error>Arvo voi olla enintään {{ availableRajat()?.max }}</mat-error>
            }
          </mat-form-field>

          <div class="viesti-napit">
            <app-primary-button actionId="Tallenna sovellusversiot" [disabled]="sovellusversiot.tallennetaan() || sovellusversiot.ladataan() || sovellusversiot.minKentta().invalid() || sovellusversiot.availableKentta().invalid()" (click)="tallennaSovellusversiot()">Tallenna</app-primary-button>
          </div>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
